import { Component, ChangeDetectionStrategy, input, output } from '@angular/core'
import { DataAttributeDirective } from '../../directives/mcm-data-attribute.directive'
import { TranslatePipe } from '@ngx-translate/core'
import { IonButton, IonIcon } from '@ionic/angular/standalone'

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DataAttributeDirective, TranslatePipe, IonButton, IonIcon]
})
export class ButtonComponent {
  readonly text = input<string>(undefined)
  readonly color = input<string>(undefined)
  readonly icon = input<string>(undefined)
  readonly iconSize = input<string>(undefined)
  readonly disabled = input(false)
  readonly extraClasses = input<string>(undefined)
  readonly isActive = input<boolean>(undefined)
  readonly expand = input<'block' | 'full'>(undefined)
  readonly qaId = input<string>(undefined)
  readonly onClick = output<boolean>()

  onHandleClick() {
    this.onClick.emit(true)
  }
}
